import { render, staticRenderFns } from "./manual-distrubute.vue?vue&type=template&id=53eafe52&scoped=true"
import script from "./manual-distrubute.vue?vue&type=script&lang=ts"
export * from "./manual-distrubute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eafe52",
  null
  
)

export default component.exports